export default __webpack_public_path__ + "static/media/file-add-outline.997d6ee9.svg";